module.exports = __webpack_public_path__ + "assets/img/6879d57370d91f2be999995482ccafc9.svg";